module.exports = __webpack_public_path__ + "img/lightning-bolt.b242c9e8.svg";